import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeoSearch } from '../../../models/geo-search';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class GeoSearchService {

    constructor(private httpClient: HttpClient, private snackbar: MatSnackBar) {
    }

    cityLookup(postalCode: string, country: string): Observable<GeoSearch[]> {
        const params = new HttpParams()
            .set('postalCode', postalCode)
            .set('country', country);
        const headers = new HttpHeaders({ Accept: 'application/ld+json '});
        return this.httpClient.get<any>(`${environment.apiUrl}/geo_search`, { headers, params }).pipe(
            map((result) => result['hydra:member']),
            catchError((error) => {
                const message = country === 'US' ? $localize`Unable to verify the ZIP code` : $localize`Unable to verify the postal code`;
                this.snackbar.open(message);
                return [];
            })
        );
    }

}
